import { render, staticRenderFns } from "./AppConfDialog.vue?vue&type=template&id=ba764868"
import script from "./AppConfDialog.vue?vue&type=script&lang=js"
export * from "./AppConfDialog.vue?vue&type=script&lang=js"
import style0 from "./AppConfDialog.vue?vue&type=style&index=0&id=ba764868&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports